import { render, staticRenderFns } from "./TemplatesTable.vue?vue&type=template&id=13cbf0ed"
import script from "./TemplatesTable.vue?vue&type=script&lang=ts"
export * from "./TemplatesTable.vue?vue&type=script&lang=ts"
import style0 from "./TemplatesTable.vue?vue&type=style&index=0&id=13cbf0ed&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports